import { hasUserRole, type UserLike } from '@/client/services/user'

export default function isUserAgeAssured(user: UserLike): boolean {
  return (
    hasUserRole(user, 'user:age_assurance:assured') ||
    hasUserRole(user, 'user:age_assurance:waived')
  )
}
